package ui.external.materialui

object ButtonSize {
    const val small = "small"
}
